import {Component, OnInit, Input} from '@angular/core';
import {FormulaireService} from 'src/app/saisie/formulaire.service';
import {LibellesService} from 'src/app/core/libelles.service';
import {FiltreService} from '../../../filtre.service';
import {UntypedFormControl} from '@angular/forms';
import {IntegerInputComponent} from '../../integer-input/integer-input.component';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
    selector: 'bis-integer-inline-input-keypad',
    templateUrl: './integer-inline-input-keypad.component.html',
    styleUrls: ['../../input/input.component.css']
})
export class IntegerInlineInputKeypadComponent extends IntegerInputComponent implements OnInit {
    @Input()
    classeSupplLabel: string = 'text-right';
    @Input()
    classeSupplInput: string = '';
    @Input()
    classeColLabel: string = 'col-2';
    @Input()
    classeColInput: string = 'col-8';
    @Input()
    valeurParDefaut: string;
    @Input()
    classeLabelErreur: string = 'col-2';

    constructor(
        protected formulaireService: FormulaireService,
        protected libelleService: LibellesService,
        protected filtreService: FiltreService,
        public modeRenduService: ModeRenduService
    ) {
        super(formulaireService, libelleService, filtreService, modeRenduService);
    }

    /** Retourne le FormControl servant à l’affichage qui n’est plus le même que le FormControl d’origine */
    get formAffichage(): UntypedFormControl {
        return this.currentControl.parent.get(this.labelAffichage) as UntypedFormControl;
    }

    /** Label à affecter au FormControl servant à l’affichage */
    get labelAffichage(): string {
        return this.label + '_affichage';
    }

    ngOnInit() {
        super.ngOnInit();
    }

    /** Besoin de réécrire cette fonction pour travailler sur le champ visible à l’écran */
    champTouche() {
        return this.formAffichage.touched;
    }

     /**
   * Lorsque le champ n’est plus sélectionné, on peut le remplir automatiquement si une valeur par défaut est saisie.
   */
  public onBlur(): void {
    if (this.valeurParDefaut && this.rootForm.get(this.label).value === null) {
      this.rootForm.get(this.label).setValue(this.valeurParDefaut);
    }
  }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }

}
